import React from 'react';

import { IDocumentChecklistItem, IRequestStatusMap, RepairPreference } from '../../declarations';
import FileSubmissionBox from './FileSubmissionBox';
import FileUploadBox from './FileUploadBox';

export interface IFileUploadRowProps {
  additionalDocumentTypes?: string[];
  documentChecklistItem?: IDocumentChecklistItem;
  fileUploadBoxChildren?: JSX.Element | JSX.Element[];
  onDocumentDownload: (id: number) => void;
  onDocumentRemove: (id: number) => void;
  onDocumentSave: (
    name: string,
    documentType: string,
    fileBase64DataUrl: string,
    requestId: number,
    checklistItemId?: number,
  ) => void;
  onSaveRepairPreferences?: (
    repairPreferenceNotes: string | null,
    sellerResponsePreference: RepairPreference,
  ) => void;
  removeChecklistDocumentRequests: IRequestStatusMap;
  uploadChecklistDocumentRequests: IRequestStatusMap;
}

export interface IFileUploadRowState {
  fileToUpload?: File;
  requestId?: number;
}

export default class FileUploadRow extends React.Component<
  IFileUploadRowProps,
  IFileUploadRowState
> {
  public state: IFileUploadRowState = {};

  public handleDocumentSave = (name: string, documentType: string) => {
    const { documentChecklistItem, onDocumentSave } = this.props;
    const { fileToUpload } = this.state;

    if (fileToUpload) {
      const fileReader = new FileReader();
      fileReader.onload = event => {
        const requestId = Number(new Date());
        onDocumentSave(
          name,
          documentType,
          (event.target as any).result as string,
          requestId,
          documentChecklistItem ? documentChecklistItem.id : undefined,
        );
        this.setState({ fileToUpload: undefined, requestId });
      };
      fileReader.readAsDataURL(fileToUpload);
    }
  };

  public handleCancel = () => this.setState({ fileToUpload: undefined });

  public handleFileSelect = (fileToUpload: File) => this.setState({ fileToUpload });

  public render(): JSX.Element {
    const {
      additionalDocumentTypes,
      documentChecklistItem,
      fileUploadBoxChildren,
      onDocumentDownload,
      onDocumentRemove,
      onSaveRepairPreferences,
      removeChecklistDocumentRequests,
      uploadChecklistDocumentRequests,
    } = this.props;
    const { fileToUpload, requestId } = this.state;
    const documentType = documentChecklistItem ? documentChecklistItem.document_type : undefined;
    const documentId =
      documentChecklistItem && documentChecklistItem.document
        ? documentChecklistItem.document.id
        : undefined;

    const removeRequestStatus = removeChecklistDocumentRequests[documentId];
    const uploadRequestStatus = uploadChecklistDocumentRequests[requestId];

    const isLoading = !!(
      (removeRequestStatus && removeRequestStatus.isLoading) ||
      (uploadRequestStatus && uploadRequestStatus.isLoading)
    );
    const error = !!(
      (removeRequestStatus && removeRequestStatus.error) ||
      (uploadRequestStatus && uploadRequestStatus.error)
    );

    return fileToUpload ? (
      <FileSubmissionBox
        documentTypes={documentType ? [documentType] : additionalDocumentTypes}
        file={fileToUpload}
        onCancel={this.handleCancel}
        onSave={this.handleDocumentSave}
        onSaveRepairPreferences={onSaveRepairPreferences}
      />
    ) : (
      <FileUploadBox
        documentChecklistItem={documentChecklistItem}
        error={error}
        isLoading={isLoading}
        onDocumentDownload={onDocumentDownload}
        onFileSelect={this.handleFileSelect}
        onDocumentRemove={onDocumentRemove}
      >
        {fileUploadBoxChildren}
      </FileUploadBox>
    );
  }
}
